import React, { useEffect, useState } from 'react';
import { db, auth } from '../firebase'; // Firebase config
import { collection, getDocs } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';

const TouristGuidePage = () => {
  const [guides, setGuides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null); // User state

  useEffect(() => {
    const fetchTouristGuides = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'touristGuides'));
        const guideList = [];
        querySnapshot.forEach((doc) => {
          guideList.push({ id: doc.id, ...doc.data() });
        });
        setGuides(guideList);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching tourist guides:', err);
        setLoading(false);
      }
    };

    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      setUser(authUser); // Update user state on login/logout
    });

    fetchTouristGuides();

    return () => unsubscribe(); // Cleanup on component unmount
  }, []);

  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        console.log('Signed out successfully');
      })
      .catch((error) => {
        console.error('Sign-out error:', error);
      });
  };

  if (loading) {
    return <div className="text-center mt-20 text-xl">جاري تحميل الأدلة السياحية...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Hero Section */}
      <div className="relative bg-cover bg-center h-96" style={{ backgroundImage: 'url(https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/405b9270158657.5b99f59ed4436.jpg)' }}>
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <h1 className="text-5xl font-extrabold text-white">اكتشف أفضل الأدلة السياحية</h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-3xl font-semibold text-gray-800">أدلة سياحية</h2>
          <div className="space-x-4">
            {user ? (
              <>
                <Link
                  to="/tourist-guide-create-offer"
                  className="py-3 px-6 bg-green-600 text-white rounded-lg hover:bg-green-700 transition duration-300"
                >
                  إنشاء عرض
                </Link>
                <button
                  onClick={handleSignOut}
                  className="py-3 px-6 bg-red-600 text-white rounded-lg hover:bg-red-700 transition duration-300"
                >
                  تسجيل الخروج
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/tourist-guide-register"
                  className="py-3 px-6 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300"
                >
                  التسجيل كدليل سياحي
                </Link>
                <Link
                  to="/tourist-guide-login"
                  className="py-3 px-6 bg-green-600 text-white rounded-lg hover:bg-green-700 transition duration-300"
                >
                  تسجيل الدخول كدليل سياحي
                </Link>
              </>
            )}
          </div>
        </div>

        {/* Guide Cards Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {guides.map((guide) => (
            <div key={guide.id} className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition duration-300">
              {/* Guide Picture */}
              {guide.picture ? (
                <img
                  src={guide.picture}
                  alt={`${guide.name}'s profile`}
                  className="w-32 h-32 rounded-full mx-auto mb-6 object-cover"
                />
              ) : (
                <div className="w-32 h-32 rounded-full bg-gray-300 mx-auto mb-6 flex items-center justify-center text-gray-600">
                  لا توجد صورة
                </div>
              )}

              {/* Guide Name */}
              <h3 className="text-xl font-semibold text-center text-gray-800">{guide.name}</h3>

              {/* Guide Bio */}
              <p className="text-gray-600 text-center mt-3">{guide.bio}</p>

              {/* View Profile Button */}
              <div className="text-center mt-4">
                <Link
                  to={`/tourist-guide/${guide.id}`}
                  className="text-green-600 hover:text-green-800 transition duration-300"
                >
                  عرض التفاصيل
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TouristGuidePage;
